<template>
    <div class="error-field-container">
        <slot></slot>
        <component :is="tag" class="error-message font-7"
                   :class="{ 'error-overflow': overflow }"
                   v-for="error in errorMessages"
                   :key="error">{{error}}</component>
    </div>
</template>

<script>
import errorFieldTypes from 'components/errorField/errorFieldTypes';
import {
    getErrorMessageForValue,
    MINLENGTH_ERROR_WITH_FIELD,
    MANDATORY_FIELD_ERROR,
    MAXLENGTH_ERROR_WITH_FIELD, DATE_FORMAT_ERROR, NUMBER_BETWEEN_ERROR,
    NUMBER_ERROR_WITH_FIELD, MIN_ERROR_WITH_FIELD, VERSION_FORMAT_ERROR
} from 'services/metaData/errors';

export default {
    name: 'ErrorField',
    props: {
        errors: Array,
        condition: Boolean,
        field: String,
        type: String,
        value: [String, Number],
        overflow: Boolean,
        tag: {
            type: String,
            default: 'span'
        }
    },
    computed: {
        errorMessages() {
            if (this.errors) {
                return this.errors
                    .filter((err) => err.condition)
                    .map((err) => this.getErrorMessage(err.field, err.type, err.value));
            }

            return this.condition ? [this.getErrorMessage(this.field, this.type, this.value)] : [];
        }
    },
    methods: {
        getErrorMessage(fieldName, type = errorFieldTypes.required, value) {
            switch (type) {
            case errorFieldTypes.min:
                return getErrorMessageForValue(MIN_ERROR_WITH_FIELD, value, fieldName);
            case errorFieldTypes.minLength:
                return getErrorMessageForValue(MINLENGTH_ERROR_WITH_FIELD, value, fieldName);
            case errorFieldTypes.maxLength:
                return getErrorMessageForValue(MAXLENGTH_ERROR_WITH_FIELD, value, fieldName);
            case errorFieldTypes.notANumber:
                return getErrorMessageForValue(NUMBER_ERROR_WITH_FIELD, fieldName);
            case errorFieldTypes.numberBetween:
                return getErrorMessageForValue(NUMBER_BETWEEN_ERROR, value, fieldName);
            case errorFieldTypes.versionFormat:
                return VERSION_FORMAT_ERROR;
            case errorFieldTypes.dateFormat:
                return DATE_FORMAT_ERROR;
            case errorFieldTypes.required:
            default:
                return getErrorMessageForValue(MANDATORY_FIELD_ERROR, fieldName);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";

.error-message {
    color: $negative;
    line-height: 20px;

    &.error-overflow {
        overflow: visible;
        white-space: nowrap;
    }
}

.error-field-container {
    display: flex;
    flex-direction: column;
}
</style>
